import { Box, CircularProgress } from '@material-ui/core';
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom'
import { fetchCalendarsRequest } from '../../../store/user/user.actions';

export const CalendlyOauth = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    useEffect(() => {
        if (location && location.search) {
            const queryParams = new URLSearchParams(location.search);
            localStorage.setItem("x-calendly-code", queryParams.get("code"));
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: 'Basic VkhBaGJvdzV3MW55aDg3Y3BJWmsxMFRLaDBqQ0VXeG8yNEhPVWNIUUFlYzpObGh5MjlSb2l0M1J6UF9IV2g4NmJnSmJINm5hbDZyU0NjM2ZmZTBraTJJ'
                },
                body: new URLSearchParams({
                    "grant_type": "authorization_code",
                    "code": queryParams.get("code"),
                    "redirect_uri": "https://app.ulalive.com/calendly/auth"
                })
            };

            fetch('https://auth.calendly.com/oauth/token', options)
                .then(response => response.json())
                .then(response => {
                    localStorage.setItem("x-calendly-accessToken", response.access_token);
                    console.log(response);
                })
                .catch(err => console.error(err))
                .finally(() => {
                    setTimeout(() => {
                        window.close();
                    }, 3000)
                })
        }
    }, [location]);
    return (
        <Box width="100vw" height="100vh" display={"flex"} justifyContent="center" alignItems={"center"}>
            <CircularProgress color="secondary" size={100} />
        </Box>
    )
}
